<template>
  <v-form ref="branchEditForm" v-model="valid">
    <div class="back-btn" @click="$router.push({name: 'delivery-index', params: {tab: 2}})">
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36 27H23.83L29.42 21.41L28 20L20 28L28 36L29.41 34.59L23.83 29H36V27Z" fill="#8C959D"/>
      </svg>
    </div>
    <v-row>
      <v-col cols="12" sm="5" md="4" xl="3">
        <h1 class="mb-16">{{ branch.id ? 'Редактировать филиал' : 'Создать филиал' }}</h1>
        <v-text-field
            v-model="branch.name"
            label="Название"
            :rules="[rules.required]"
            required
            outlined
        ></v-text-field>
        <v-tabs v-model="tabLang">
          <v-tab>RU</v-tab>
          <v-tab>UA</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabLang" class="pt-5">
          <v-tab-item>
            <v-text-field
                v-model="branch.self_delivery_name"
                label="Название для самовывоза"
                :rules="[rules.required]"
                required
                outlined
            ></v-text-field>
            <v-text-field
                v-model="branch.self_delivery_address"
                label="Адрес для самовывоза"
                :rules="[rules.required]"
                required
                outlined
            ></v-text-field>
          </v-tab-item>
          <v-tab-item>
            <v-text-field
                v-model="branch.self_delivery_name_ua"
                label="Название для самовывоза"
                :rules="[rules.required]"
                required
                outlined
            ></v-text-field>
            <v-text-field
                v-model="branch.self_delivery_address_ua"
                label="Адрес для самовывоза"
                :rules="[rules.required]"
                required
                outlined
            ></v-text-field>
          </v-tab-item>
        </v-tabs-items>

        <v-autocomplete
            v-model="branch.disabled_products"
            :items="products"
            :loading="isLoading"
            :search-input.sync="search"
            class="d-none"
            hide-no-data
            multiple
            item-text="name"
            item-value="id"
            label="Выключенные блюда"
            outlined
            return-object
        ></v-autocomplete>

        <v-autocomplete
            v-model="branch.disabled_categories"
            :items="categories"
            :loading="isLoading"
            hide-no-data
            multiple
            class="d-none"
            item-text="name"
            item-value="id"
            label="Выключенные категории"
            outlined
            return-object
        ></v-autocomplete>


        <v-autocomplete
            v-model="branch.online_pay_account"
            :items="onlinePayAccounts"
            :loading="isLoading"
            hide-no-data
            label="Счет онлайн оплаты"
            item-text="name"
            item-value="id"
            outlined
            return-object
        ></v-autocomplete>

        <v-autocomplete
            v-model="branch.checkbox_login_id"
            :items="checkboxLogins"
            :loading="isLoading"
            hide-no-data
            label="Checkbox аккаунт (касса)"
            item-text="name"
            item-value="id"
            outlined
            clearable
        >
          <!-- Показываем логин как подсказку в списке -->
          <template #item="{ item }">
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
              <v-list-item-subtitle class="grey--text">{{ item.login }}</v-list-item-subtitle>
            </v-list-item-content>
          </template>

          <!-- В поле показываем название + логин -->
          <template #selection="{ item }">
            {{ item.name }}
            <span class="grey--text ml-1 text-caption">({{ item.login }})</span>
          </template>
        </v-autocomplete>

        <v-checkbox
            dense
            hide-details
            v-model="branch.is_self_delivery"
            label="Самовывоз"
            class="mb-5"
        >
        </v-checkbox>

        <v-checkbox
            dense
            hide-details
            v-model="branch.is_disabled"
            label="Выключен"
            class="mb-5"
        >
        </v-checkbox>

        <v-checkbox
            dense
            hide-details
            v-model="branch.is_disabled_date"
            label="Выключен сегодня"
            class="mb-5"
        >
        </v-checkbox>

        <v-text-field
            v-model="branch.ip"
            label="IP принтера для чека"
            outlined
        ></v-text-field>
        <v-text-field
            v-model="branch.ip2"
            label="Резервный IP принтера для чека"
            outlined
        ></v-text-field>

        <v-text-field
            v-model="branch.port"
            label="Port принтера для чека"
            outlined
        ></v-text-field>

        <v-btn :loading="loadingButton" v-if="id" @click="update">Сохранить</v-btn>
        <v-btn :loading="loadingButton" v-else @click="create">Создать</v-btn>
      </v-col>

      <v-col cols="12" sm="7" md="8" style="padding-top: 70px;">
        <v-text-field
            v-model="branch.url"
            label="Ссылка для гугл карт"
            outlined
        ></v-text-field>
      </v-col>

      <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          :color="snackbarColor"
          right
          top
      >
        {{ snackbarText }}
      </v-snackbar>
    </v-row>
  </v-form>
</template>

<script>
// @ is an alias to /src
import BranchService from "../../../api/BranchService";
import moment from 'moment'
import ProductService from "@/api/ProductService";
import CategoryService from "@/api/CategoryService";
import OnlinePayAccountService from "@/api/OnlinePayAccountService";
import GmapCluster from "vue2-google-maps/dist/components/cluster";
import CheckboxLoginService from "@/api/CheckboxLoginService";

export default {
  name: 'BranchEdit',
  props: {
    id: {
      default: null,
    }
  },
  components: {GmapCluster},
  data: () => ({
    checkboxLogins: [],
    changingCenter: {lat: 46.482952, lng: 30.712481},
    changingZoom: 11,
    search: '',
    isLoading: false,
    products: [],
    categories: [],
    items: [],
    snackbar: false,
    timeout: 2000,
    snackbarText: '',
    snackbarColor: '',
    timeModal: false,
    valid: true,
    rules: {
      required: value => !!value || 'Нужно заполнить',
      requiredSelect: v => {
        return !!v.id || 'Нужно заполнить'
      },
    },
    tabLang: '',
    onlinePayAccounts: [],
    branch: {
      name: '',
      default_delivery_time: '00:00',
      delivery_time: '00:00',
      self_delivery_name: '',
      self_delivery_name_ua: '',
      self_delivery_address: '',
      self_delivery_address_ua: '',
      ip: '',
      ip2: '',
      port: '',
      is_self_delivery: false,
      is_disabled_date: false,
      is_disabled: false,
      disabled_products: [],
      disabled_categories: [],
      url: '',
      checkbox_login_id: null,
    },
    loading: true,
    loadingButton: false,
  }),
  mounted() {
    this.init()

    CategoryService.list({show_all: true}).then((response) => {
      this.categories = response.data
    })

    OnlinePayAccountService.list().then((response) => {
      console.log(response.data)
      this.onlinePayAccounts = response.data
    })

    CheckboxLoginService.list().then((response) => {
      this.checkboxLogins = response.data
    })
  },
  watch: {
    search (val) {
      if (this.isLoading) return

      this.isLoading = true

      ProductService.findByName({word: this.search}).then(response => {
        this.products = response.data.concat(this.branch.disabled_products);

      }).finally(response => {
        this.isLoading = false
      });
    },
  },
  methods: {
    validate() {
      this.$refs.branchEditForm.validate()
    },

    init() {
      if (this.id) {
        BranchService.get(this.id)
            .then(response => {
              this.branch = response.data;
              this.branch.is_disabled_date = response.data.is_disabled_date === (new Date()).toISOString().split('T')[0];

              this.updateSelectedCoords();

              this.products = this.branch.disabled_products
              this.loading = false
            });
      }
    },
    update() {
      this.validate()
      if (!this.valid) {
        return false
      }
      this.loadingButton = true;
      let formData = this.getData();

      BranchService.update(formData).then(response => {
        this.snackbar = true;
        this.snackbarText = 'Филиал успешно обновлен';
        this.snackbarColor = 'success';
      }).catch(error => {
        this.snackbar = true;
        this.snackbarText = 'Ошибка при обновлении филиала';
        this.snackbarColor = 'error';
      }).finally(() => {
        this.loadingButton = false
      })
    },
    create() {
      this.validate()
      if (!this.valid) {
        return false
      }
      this.loadingButton = true;
      var formData = this.getData();

      BranchService.create(formData).then(response => {
        this.snackbar = true;
        this.snackbarText = 'Филиал успешно создан';
        this.snackbarColor = 'success';
        this.$router.push({name: 'branch-edit', params: {id: response.data.id}})
        this.init();
      }).catch(error => {
        this.snackbar = true;
        this.snackbarText = 'Ошибка при создании филиала';
        this.snackbarColor = 'error';
      }).finally(() => {
        this.loadingButton = false
      })
    },
    getData() {
      let formData = new FormData();
      let time = moment('2020-01-01 ' + this.branch.default_delivery_time).format('HH:mm:ss')

      console.log(this.branch.is_disabled);
      formData.append('id', this.id);
      formData.append('name', this.branch.name);
      formData.append('self_delivery_name', this.branch.self_delivery_name);
      formData.append('self_delivery_name_ua', this.branch.self_delivery_name_ua);
      formData.append('self_delivery_address', this.branch.self_delivery_address);
      formData.append('self_delivery_address_ua', this.branch.self_delivery_address_ua);
      formData.append('online_pay_account_id', this.branch.online_pay_account ? this.branch.online_pay_account.id : null);
      formData.append('ip', this.branch.ip ? this.branch.ip : null);
      formData.append('ip2', this.branch.ip2 ? this.branch.ip2 : null);
      formData.append('port', this.branch.port ? this.branch.port : null);
      formData.append('is_self_delivery', this.branch.is_self_delivery ? 1 : 0);
      formData.append('is_disabled', this.branch.is_disabled ? 1 : 0);
      formData.append('is_disabled_date', this.branch.is_disabled_date ? (new Date()).toISOString().split('T')[0] : '2000-01-01');
      formData.append('default_delivery_time', '2020-01-01 00:00:00');
      formData.append('delivery_time', '2020-01-01 00:00:00');
      formData.append('checkbox_login_id', this.branch.checkbox_login_id || '');
      formData.append('url', this.branch.url);
      if(this.branch.disabled_products && this.branch.disabled_products.length){
        this.branch.disabled_products.forEach((val) => {
          formData.append('disabled_products[]', val.id);
        })
      }

      if(this.branch.disabled_categories && this.branch.disabled_categories.length){
        this.branch.disabled_categories.forEach((val) => {
          formData.append('disabled_categories[]', val.id);
        })
      }

      return formData;
    }
  },
}
</script>

<style scoped lang="scss">
.image-placeholder {
  width: 100%;
  height: 100%;
  background-color: #F3F7FC;
  border-radius: 4px;
}

.branch-images .v-image {
  max-height: 374px;
}

.branch {
  position: relative;

  &:before {
    content: "";
    padding-top: 100%;
    display: block;
  }

  .content {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    height: 100%;
    background-color: #F8FBFF;
    border-right-style: solid;

    .img {
      height: 3.541vw;
      margin-top: .83vw;
    }

    .name {
      margin-top: .72vw;
      text-align: center;
      color: #8C959D;
    }
  }
}
</style>
